// extracted by mini-css-extract-plugin
export default {"edit":"styles_edit__WmgWt","fields":"styles_fields__Vh-68","delete":"styles_delete__Uf592","delete-button":"styles_delete-button__62-Fg"};